module.exports = __webpack_public_path__ + "static/media/Semi2.b42276aa.png";